<template>
    <v-list class="pt-0">
        <v-toolbar flat dense>
            <v-spacer />
            <v-btn icon flat @click="show = false" color="primary">
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <p class="title pa-3">Bienvenue {{ connected.prenom }}</p>
        <template v-for="(item, index) in items">
            <v-divider v-if="item.divider" :key="index" />
            <v-list-tile v-else
                :key="item.text"
                :to="item.to"
                v-rights="item.rights"
                @click="(item.click && item.click(item)) || null">
                <v-list-tile-action>
                    <v-icon>{{ item.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>{{ item.text }}</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
        </template>
    </v-list>
</template>

<script>
export default {
    name: 'pad-menu-variant',
    props: {
        value: { type: Boolean }
    },
    computed: {
        show: {
            get() {
                return this.value
            },
            set(v) {
                this.$emit('input', v)
            }
        },
        connected() {
            return this.$store.getters['auth/user']
        },
        items() {
            return [
                { to: 'lots', rights: ['apad', 'view'], icon: 'view_list', text: 'Lots' },
                { divider: true },
                { click: this.reload, icon: 'refresh', rights: ['apad', 'view'], text: 'Rafraîchir' },
                { click: this.logout, rights: ['apad', 'view'], icon: 'undo', text: 'Logout' }
            ]
        }
    },
    methods: {
        reload() {
            window.location.reload()
        },
        logout() {
            return this.$store.dispatch('auth/logout')
                .then(() => this.$router.push({ name: 'login' }))
        }
    }
}
</script>
